export default "<button type=\"button\" class=\"btn btn-primary btn-lg\">Large button</button>\r\n"